module.exports = __webpack_public_path__ + "static/img/img-8-1.501b457.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-8-1.png
// module id = 2BAk
// module chunks = 0